<template>
  <a-tabs
    v-model:activeKey="activeKey"
    :animated="false"
    @change="(e) => changePage(1, e)"
  >
    <a-tab-pane key="1" :tab="'文章（' + countData.article + '）'">
      <div class="tab-blank" v-if="articles.length === 0">
        <a-empty />
      </div>
      <div class="list" v-else>
        <div class="item" v-for="item in articles" :key="item.res_id">
          <div class="title">
            <router-link
              :to="{ path: '/view/detail', query: { id: item.res_id } }"
              target="_blank"
              >{{ item.title }}</router-link
            >
            <a-tag v-if="item.classify_id === 1" color="#FFAD28">
              {{ item.classify_name }}
            </a-tag>
            <a-tag v-else-if="item.classify_id === 2" color="#FF455B">
              {{ item.classify_name }}
            </a-tag>
            <a-tag v-else-if="item.classify_id === 3" color="#E75934">
              {{ item.classify_name }}
            </a-tag>
            <a-tag v-else-if="item.classify_id === 4" color="#26BFBF">
              {{ item.classify_name }}
            </a-tag>
            <div class="ctrls" v-show="loginUserId == userId">
              <a-button
                type="link"
                danger
                @click="praise(item, 1)"
                style="font-size: 15px"
              >
                取消点赞</a-button
              >
            </div>
          </div>
          <div class="attrs">
            <span>{{ item.addtime }}</span>

            <span class="praise" :class="{ praised: item.isPraise }">
              <i class="iconfont icon-dianzan_kuai"></i
              >{{ numWan(item.praise_qua) }}
            </span>
            <span class="collection" :class="{ collected: item.isCollection }">
              <i class="iconfont icon-shoucang"></i
              >{{ numWan(item.collect_qua) }}
            </span>
            <span class="browse">
              <i class="iconfont icon-liulan"></i>{{ numWan(item.browse_qua) }}
            </span>
          </div>
        </div>
        <div class="page" v-if="page.allPage && page.allPage > 1">
          <a-pagination
            v-model:current="page.currentPage"
            :total="page.allSize"
            :show-total="(total) => `共 ${page.allSize} 篇`"
            :page-size="10"
            show-quick-jumper
            @change="
              (e) => {
                changePage(e, 1);
              }
            "
          />
        </div>
      </div>
    </a-tab-pane>
    <a-tab-pane key="2" :tab="'论文（' + countData.essay + '）'">
      <div class="tab-blank" v-if="essays.length === 0">
        <a-empty />
      </div>
      <div class="list" v-else>
        <div class="item" v-for="item in essays" :key="item.res_id">
          <div class="title">
            <router-link
              :to="{
                path: '/essay_detail',
                query: { id: item.res_id, type: 1 },
              }"
              target="_blank"
              >{{ item.title }}</router-link
            >

            <div class="ctrls" v-show="loginUserId == userId">
              <a-button
                type="link"
                danger
                @click="praise(item, 2)"
                style="font-size: 15px"
              >
                取消点赞</a-button
              >
            </div>
          </div>
          <div class="attrs">
            <span> {{ item.addtime }}</span>
            <span class="praise" :class="{ praised: item.isPraise }">
              <i class="iconfont icon-dianzan_kuai"></i>{{ item.praise_qua }}
            </span>
            <span class="collection" :class="{ collected: item.isCollection }">
              <i class="iconfont icon-shoucang"></i
              >{{ numWan(item.collect_qua) }}
            </span>
            <span class="browse">
              <i class="iconfont icon-liulan"></i>{{ numWan(item.browse_qua) }}
            </span>
          </div>
        </div>
        <div class="page" v-if="page2.allPage && page2.allPage > 1">
          <a-pagination
            v-model:current="page2.currentPage"
            :total="page2.allSize"
            :show-total="(total) => `共 ${page2.allSize} 篇`"
            :page-size="10"
            show-quick-jumper
            @change="
              (e) => {
                changePage(e, 2);
              }
            "
          />
        </div>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "vue";
import Http from "@/until/http";
import { useRoute } from "vue-router";
import {
  confirmLogin,
  getCookie,
  getLocalItem,
  numWan,
} from "../../until/tools";
export default defineComponent({
  setup() {
    const state = reactive({
      activeKey: "1",
      articles: [],
      essays: [],
      countData: {
        article: 0,
        essay: 0,
      },
      page: {},
      page2: {},
    });
    const route = useRoute();

    const keywords = computed(() => {
      return route.query.keyword;
    });
    const userId = computed(() => {
      return parseInt(route.query.id);
    });
    const loginUserId = computed(() => {
      // return parseInt(getLocalItem("userInfo").userId);
        return getLocalItem('userInfo')?parseInt(getLocalItem('userInfo').userId):null;
    });

    const getList = () => {
      Http.getUserPraises({
        userId: userId.value,
        classifyCode: "07",
        keyword: keywords.value,
      }).then((res) => {
        if (res.page) {
          Object.assign(state.countData, {
            article: res.page.allSize,
          });
          Object.assign(state, {
            articles: res.praiseList,
            page: res.page,
          });
        }
      });

      Http.getUserPraises({
        userId: userId.value,
        classifyCode: "04",
        keyword: keywords.value,
      }).then((res) => {
        if (res.page) {
          Object.assign(state.countData, {
            essay: res.page.allSize,
          });
          Object.assign(state, {
            essays: res.praiseList,
            page2: res.page,
          });
        }
      });
    };

    const praise = (item, type) => {
      let sid = getCookie("z_sid");
      if (!sid) {
        confirmLogin();
      }
      if (type === 1) {
        let params = {
          resId: item.res_id,
          resUserId: item.resUserId,
          flag: item.isPraise ? 1 : 0,
        };
        Http.articlePraise(params).then((res) => {
          if (res) {
            if (res.success) {

              const {allSize,currentPage,pageSize} = state.page;                  
                let allPage = Math.ceil((allSize-1)/pageSize);
                let page;
                if(allPage<currentPage) {
                  page = allPage;
                } else {
                  page = currentPage;
              }
              if(page<1) {
                page=1;
              }

              Http.getUserPraises({
                userId: userId.value,
                classifyCode: "07",
                keyword: keywords.value,
                currentPage:page
              }).then((res) => {
                if (res.page) {
                  Object.assign(state.countData, {
                    article: res.page.allSize,
                  });
                  Object.assign(state, {
                    articles: res.praiseList,
                    page:res.page
                  });
                }
              });
            }
          }
        });
      } else if (type === 2) {
        let params = {
          resId: item.res_id,
          resUserId: item.user_id ? item.user_id : 0,
          flag: item.isPraise ? 1 : 0,
        };
        Http.setEssayPraiseStatus(params).then((res) => {
          if (res) {
            const {allSize,currentPage,pageSize} = state.page2;                  
              let allPage = Math.ceil((allSize-1)/pageSize);
              let page;
              if(allPage<currentPage) {
                page = allPage;
              } else {
                page = currentPage;
            }
            if(page<1) {
              page=1;
            }
            Http.getUserPraises({
              userId: userId.value,
              classifyCode: "04",
              keyword: keywords.value,
              currentPage:page
            }).then((res) => {
              if (res.page) {
                Object.assign(state.countData, {
                  essay: res.page.allSize,
                });
                Object.assign(state, {
                  essays: res.praiseList,
                  page2:res.page
                });
              }
            });
          }
        });
      }
    };

    const changePage = (num, type) => {
      if (type === 1 || type === "1") {
        Http.getUserPraises({
          userId: userId.value,
          classifyCode: "07",
          keyword: keywords.value,
          currentPage: num,
        }).then((res) => {
          if (res.page) {
            Object.assign(state.countData, {
              article: res.page.allSize,
            });
            Object.assign(state, {
              articles: res.praiseList,
              page: res.page,
            });
          }
        });
      } else if (type === 2 || type === "2") {
        Http.getUserPraises({
          userId: userId.value,
          classifyCode: "04",
          keyword: keywords.value,
          currentPage: num,
        }).then((res) => {
          if (res.page) {
            Object.assign(state.countData, {
              essay: res.page.allSize,
            });
            Object.assign(state, {
              essays: res.praiseList,
              page2: res.page,
            });
          }
        });
      }
    };

    watch(keywords, () => {
      getList();
    });

    onMounted(() => {
      getList();
    });

    return {
      ...toRefs(state),
      praise,
      numWan,
      changePage,
      userId,
      loginUserId,
    };
  },
});
</script>

<style>
</style>